module.exports = __webpack_public_path__ + "static/media/Email.12f89b28.svg";